var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1931_21411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5706 0.191406L36.0855 3.69989C36.4261 4.34734 36.7951 4.92042 37.2297 5.45413C38.5038 7.00567 39.6915 8.66161 40.7846 10.4106C43.3514 14.5666 45.0827 19.1818 46.3192 24.1733C47.0606 27.2225 47.4633 30.3504 47.4935 33.5133C47.6177 42.9691 44.9887 51.0885 39.6883 57.8364C38.8261 58.9065 37.8947 59.8882 36.9033 60.7718C36.3782 60.7718 36.1298 60.2753 35.9134 59.8181C35.5193 58.9704 35.257 58.0395 35.14 57.073C34.9537 55.9291 34.8313 54.7851 34.8917 53.6039V53.0702C34.8491 52.9565 34.3861 0.460448 34.5706 0.191406Z",
    fill: "#599636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5718 0.0752509C34.5097 -0.0778625 34.4476 0.0380662 34.3855 0.112436C34.4157 0.878003 34.1993 1.56045 33.8605 2.21228C33.4879 2.85973 32.9948 3.35625 32.4999 3.88996C29.7503 6.82537 27.5862 10.371 25.8531 14.3367C23.547 19.6738 22.3585 25.3937 22.0214 31.4154C21.8671 33.5874 22.5784 41.2518 23.1337 43.4632C24.6486 49.334 27.3697 54.2533 30.8945 58.523C31.7602 59.5511 32.6861 60.5047 33.6441 61.4212C33.9226 61.4212 33.9527 61.115 34.0166 60.8875C34.1387 60.4008 34.2318 59.9036 34.2951 59.4001L34.9159 53.6824L34.5718 0.0752509Z",
    fill: "#6CAC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0872 63.095C36.1493 62.2201 36.4899 61.4939 36.8606 60.7699C36.4881 60.5796 36.2114 60.2011 35.995 59.779C35.8083 59.3793 35.6539 58.958 35.5337 58.5213C35.1009 56.9201 35.0087 55.2403 34.8845 53.6041V52.6133C34.7302 52.7664 34.6982 54.0613 34.6982 54.2538C34.608 55.983 34.4219 57.7027 34.1412 59.4006C34.049 60.0874 33.9869 60.772 33.6445 61.3823C33.6445 61.4589 33.6445 61.5354 33.6747 61.6492C34.2317 63.6703 34.3843 65.7285 34.4783 67.8262V68.5918C34.4783 69.5061 34.4481 69.3136 35.0637 69.6198C35.312 69.7335 35.5887 69.7729 35.8371 70.0004C36.0233 70.0004 36.0535 69.8101 36.0535 69.657L35.9613 68.3993V64.8908C35.9311 64.2783 36.0233 63.6703 36.0854 63.0972L36.0872 63.095Z",
    fill: "#C2BFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1931_21411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.51b0eba47fbb4a2c5b0b910a61a6cc9b.svg";
export { ForwardRef as ReactComponent };